
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 .25a.75.75 0 01.743.648L7.75 1v5.25H13a.75.75 0 01.102 1.493L13 7.75H7.75V13a.75.75 0 01-1.493.102L6.25 13V7.75H1a.75.75 0 01-.102-1.493L1 6.25h5.25V1A.75.75 0 017 .25z","fill":"#FFF","fill-rule":"nonzero"}})])
          )
        }
      }
    